import '../app.es6';
import angular from 'angular';

const DirectiveName = 'resize';
class ResizeController {
  /* @ngInject */
  constructor ($scope, $element, SharedState) {
    this.$scope = $scope;
    this.$elm = $element;
    this.sharedState = SharedState;

    ResizeController.$inject = ['$scope', '$element', 'SharedState'];
  }
}

function ddo () {
  return {
    restrict: 'A',
    controller: ResizeController,
    controllerAs: 'resizeController',
    require: DirectiveName,
    scope: {
      name: '@' + DirectiveName
    },
    link: function (scope, elem, attrs, controller) {
      if (elem[0].nodeName === 'TEXTAREA') {
        // textareaの初期設定
        elem.css({'lineHeight': '20px', 'height': '60px', 'min-height': '60px'});

        // 初期入力情報によってtextareaを変動
        scope.$watch(attrs.ngModel, function () {
          var textHeight = elem[0].scrollHeight;
          elem.css('height', textHeight + 'px');
        });

        // 文字入力時のtextarea設定値変動
        var resize = function (e) {
          var argObj = e.target;
          argObj.style.height = '10px';
          var wSclollHeight = parseInt(argObj.scrollHeight);
          var wLineH = parseInt(argObj.style.lineHeight.replace(/px/, ''));
          if (wSclollHeight < (wLineH * 2)) {
            wSclollHeight = (wLineH * 2);
          }
          elem.css('height', wSclollHeight + 'px');
        };
        elem.on('input', resize);
      }
    }
  };
}

angular.module('myApp').directive(DirectiveName, ddo);



// WEBPACK FOOTER //
// ./app/components/resize.es6